// removed by extract-text-webpack-plugin
module.exports = {"resizable-h":"_2b7Y-u3LJXBXbUXevPhHyq","first":"_2XJigfygUmDeOn4igcd_AF","separator":"ZgqggoJmMCgTHNET-cAVn","second":"_18lMffZjECfBHvKayz59Jm","resizing":"_3BrUsoHKx2Fn5TBq1x-2h4","resizable-v":"TtUDUk6CCujEoHjCREBTL","spin":"_1YTchMwRkSvbgcifBnCPmU"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/Resizable/styles.scss
// module id = 917
// module chunks = 18